import FieldRenderer from '../FieldRenderer';
import ModuleCard from '../ModuleCard';

interface CustomModuleProps {
  module: {
    id: string;
    type: string;
    name: string;
    nameEn?: string;
    icon?: string;
    headerStyle?: string;
    headerColor?: string;
    fields: any[];
    settings: any;
  };
  event: any;
}

export default function CustomModule({ module }: CustomModuleProps) {
  return (
    <ModuleCard
      title={module.name}
      titleEn={module.nameEn}
    >
      <>
        {module.fields?.map((field) => (
          <FieldRenderer key={field.id} field={field} />
        ))}
      </>
    </ModuleCard>
  );
}
